import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { OidcPaths } from 'Feature/Auth/Constant/OidcPaths';
import AutoLoginCallbackPage from 'Feature/Auth/Pages/AutoLoginCallbackPage';
import SignInCallbackPage from 'Feature/Auth/Pages/SignInCallbackPage';
import SignOutCallbackPage from 'Feature/Auth/Pages/SignOutCallbackPage';
import SignOutPage from 'Feature/Auth/Pages/SignOutPage';
import { getCartItemsTotalCountByCurrentUser } from 'Feature/Orders/Common/Actions/Thunks/getCartItemsTotalCountByCurrentUser';
import AppRoutes from 'Shared/Routes/AppRoutes';
import MainRoute from 'Shared/Routes/Components/MainRoute';
import useAppDispatch from 'Shared/Store/dispatch/useAppDispatch';
import { ClearAllToasts } from 'Shared/Toast';

const App: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    ClearAllToasts();
  }, [location]);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) dispatch(getCartItemsTotalCountByCurrentUser());
  }, []);

  return (
    <>
      <Routes>
        <Route path={OidcPaths.Oidc.SignInCallback} element={<SignInCallbackPage />} />
        <Route path={OidcPaths.Oidc.SignOutCallBack} element={<SignOutCallbackPage />} />
        <Route path={OidcPaths.Oidc.SignOut} element={<SignOutPage />} />
        <Route path={OidcPaths.Oidc.AutoLogin} element={<AutoLoginCallbackPage />} />
        <Route path='*' element={<MainRoute appRoutes={AppRoutes} />} />
      </Routes>
      <ToastContainer />
    </>
  );
};

export default App;
